import React from "react";
import { Map, BusFront, UserCheck, MessagesSquare } from "lucide-react";
import PageWrapper from "../components/PageWrapper";
import PageHero from "../components/PageHero";
import BusImage from "../components/BusImage";
import FeatureCard from "../components/FeatureCard";
import {
  LiveTrackingCard,
  SafetyStatusCard,
  TodayOperationsCard,
} from "../components/StatusCards";

const features = [
  {
    icon: Map,
    title: "Route Planning",
    description:
      "Smart route optimization for maximum safety, efficiency, and on-time performance.",
  },
  {
    icon: BusFront,
    title: "Bus & Driver Management",
    description:
      "Well-maintained buses and trained, verified drivers for a safe and reliable journey.",
  },
  {
    icon: UserCheck,
    title: "Student Pickup & Drop Operations",
    description:
      "Punctual pickups and safe drops with real-time tracking and strict operation protocols.",
  },
  {
    icon: MessagesSquare,
    title: "Parent & School Communication",
    description:
      "Real-time updates, instant alerts, and seamless communication with parents and school staff.",
  },
];

const Services = () => {
  return (
    <PageWrapper testId="services-page">
      <PageHero
        title={
          <>
            <span className="brand-blue">End-to-End School</span>
            <br />
            <span className="brand-blue">Transport Services</span>
            <span className="text-amber-500">.</span>
          </>
        }
        description="We manage every aspect of your school transport—routes, buses, staff, daily operations, and communication—so schools can focus on what matters most: students."
        cta={{ label: "How We Help", to: "/technology" }}
        rightContent={
          <div className="relative xl:min-h-[460px]">
            <BusImage variant="services" />
            <div className="hidden xl:flex flex-col gap-4 absolute right-0 top-0">
              <LiveTrackingCard />
              <SafetyStatusCard delay={0.4} />
            </div>
            <div className="xl:hidden mt-6 grid sm:grid-cols-2 gap-4">
              <LiveTrackingCard />
              <SafetyStatusCard delay={0.4} />
              <TodayOperationsCard />
            </div>
          </div>
        }
      />

      <section
        className="max-w-[1280px] mx-auto px-5 lg:px-10 -mt-2 mb-14"
        data-testid="services-features"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <FeatureCard
              key={f.title}
              icon={f.icon}
              title={f.title}
              description={f.description}
              variant="icon-bg"
              index={i}
              testId={`services-feature-${i}`}
            />
          ))}
        </div>
      </section>
    </PageWrapper>
  );
};

export default Services;
